import { cn } from '@agos/ui'

import { lineNoteOf } from '../order-builder/line-note'
import { KITCHEN_TEXT } from './item-name'

/**
 * A line's own note, under the item it was written about - `FRONTEND.md` §9.691, owner #3 (O55).
 *
 * **The owner:** *"K 3 tie poznámky aby ukazovalo v kuchyni len tie ku každému produktu lebo to je
 * pre kuchyňu len"* - and asked whether the order's own note then goes away, the answer was both
 * (`OWNER-QUESTIONS.md` #117): this one under each item, the order note kept at the top of the card.
 *
 * **Amber and italic, with the order note's own 📝**, so a cook reads the two as one kind of thing:
 * words a person wrote, as against the ingredients the menu wrote. **16 px** (`KITCHEN_TEXT.lineNote`, §9.810,
 * owner O156; was 14 px) and bold, larger than the composition chips, because a note the cook cannot read from
 * the pass is a note the customer does not get.
 *
 * It dims and strikes through with the item when the cook taps it done, like the name above it.
 * Nothing is drawn for a line without one - a blank, a `null` and an absent key are all *no note*.
 */
export function KitchenLineNote({
  line,
  done = false,
}: {
  line: { note?: unknown }
  done?: boolean
}) {
  const note = lineNoteOf(line)
  if (note === undefined) return null
  return (
    <p
      data-kitchen-line-note
      className={cn(
        KITCHEN_TEXT.lineNote,
        'mt-0.5 font-bold italic leading-tight break-words',
        done ? 'text-amber-700/40 dark:text-amber-300/40 line-through' : 'text-amber-700 dark:text-amber-300',
      )}
    >
      📝 {note}
    </p>
  )
}
